import React from 'react';

import Header from '../../layout/Header.jsx';
import ListBreeds from '../../lists/ListBreeds.jsx';

const PageBreeds = () => (
  <div>
    <Header>Breeds</Header>
    <ListBreeds />
  </div>
);

export default PageBreeds;
